module.exports = __webpack_public_path__ + "static/media/ic-drawer-menu-brief.86f036c2.svg";